var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "13px",
        height: "8px",
        viewBox: "0 0 13 8",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs"),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Icons",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "global-arrow",
                transform: "translate(-10.000000, -12.000000)",
                fill: _vm.color
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "dropdown-arrow",
                    transform: "translate(10.000000, 12.000000)"
                  }
                },
                [
                  _c("polygon", {
                    attrs: {
                      id: "dropdown_arrow",
                      points: "6.31 4.72 11.37 0 13 1.87 6.31 8 0 1.87 1.63 0"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }